"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var Glp_1 = __importDefault(require("../Glp"));
var LeftMenu = function (_a) {
    var isNotFoundPage = _a.isNotFoundPage, pages = _a.pages, _b = _a.promoLink, promoLink = _b === void 0 ? '/' : _b;
    var t = (0, next_intl_1.useTranslations)('translation');
    var lang = (0, next_intl_1.useLocale)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var openProfileMenu = (0, apps_shared_1.useOpenProfileMenu)();
    var headerLinks = (0, react_1.useMemo)(function () { return ({
        promotions: "/".concat(lang, "/promotions"),
        payments: "/".concat(lang, "/payments"),
        tournaments: "/".concat(lang, "/tournaments"),
        vip: "/".concat(lang, "/vip"),
        sports: "/".concat(lang, "/betting/sports/live"),
        promo: "/".concat(lang).concat(promoLink),
    }); }, [lang, promoLink]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.menuWrapper }, Object.keys(breakpoints).length > 0 &&
        (breakpoints.mobile || breakpoints.tablet) ? (react_1.default.createElement(react_1.default.Fragment, null,
        !isNotFoundPage && (react_1.default.createElement(react_1.Suspense, { fallback: false },
            react_1.default.createElement("button", { className: styles_module_scss_1.default.burgerMenuButton, onClick: openProfileMenu }))),
        pages.includes('glp') ? react_1.default.createElement(Glp_1.default, null) : null)) : (react_1.default.createElement("ul", { className: styles_module_scss_1.default.listMenu },
        pages.includes('promotions') ? (react_1.default.createElement("li", null,
            react_1.default.createElement(ui_components_1.NavLink, { className: styles_module_scss_1.default.navLink, href: headerLinks.promotions, activeClassName: styles_module_scss_1.default.activeNavLink }, t('promotions')))) : null,
        pages.includes('payments') ? (react_1.default.createElement("li", null,
            react_1.default.createElement(ui_components_1.NavLink, { className: styles_module_scss_1.default.navLink, href: headerLinks.payments, activeClassName: styles_module_scss_1.default.activeNavLink }, t('payments')))) : null,
        pages.includes('tournaments') ? (react_1.default.createElement("li", null,
            react_1.default.createElement(ui_components_1.NavLink, { className: styles_module_scss_1.default.navLink, href: headerLinks.tournaments, activeClassName: styles_module_scss_1.default.activeNavLink }, t('tournaments')))) : null,
        pages.includes('vip') ? (react_1.default.createElement("li", null,
            react_1.default.createElement(ui_components_1.NavLink, { className: styles_module_scss_1.default.navLink, href: headerLinks.vip, activeClassName: styles_module_scss_1.default.activeNavLink }, t('vipclub')))) : null,
        pages.includes('sports') ? (react_1.default.createElement("li", null,
            react_1.default.createElement(ui_components_1.NavLink, { className: styles_module_scss_1.default.navLink, href: headerLinks.sports, activeClassName: styles_module_scss_1.default.activeNavLink }, t('sports')))) : null,
        pages.includes('promo') ? (react_1.default.createElement("li", null,
            react_1.default.createElement(ui_components_1.NavLink, { className: styles_module_scss_1.default.navLink, href: headerLinks.promo, activeClassName: styles_module_scss_1.default.activeNavLink }, t('promo')))) : null,
        pages.includes('glp') ? react_1.default.createElement(Glp_1.default, null) : null))));
};
exports.default = react_1.default.memo(LeftMenu);
